/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteRace } from '../fn/races/delete-race';
import { DeleteRace$Params } from '../fn/races/delete-race';
import { Race } from '../models/race';
import { races } from '../fn/races/races';
import { Races$Params } from '../fn/races/races';
import { racesRaceGuidPost } from '../fn/races/races-race-guid-post';
import { RacesRaceGuidPost$Params } from '../fn/races/races-race-guid-post';

@Injectable({ providedIn: 'root' })
export class RacesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `races()` */
  static readonly RacesPath = '/races';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `races()` instead.
   *
   * This method doesn't expect any request body.
   */
  races$Response(params?: Races$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Race>>> {
    const obs = races(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `races$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  races(params?: Races$Params, context?: HttpContext): Observable<Array<Race>> {
    const resp = this.races$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Race>>): Array<Race> => r.body)
    );
  }

  /** Path part for operation `racesRaceGuidPost()` */
  static readonly RacesRaceGuidPostPath = '/races/{raceGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `racesRaceGuidPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  racesRaceGuidPost$Response(params: RacesRaceGuidPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Race>> {
    const obs = racesRaceGuidPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `racesRaceGuidPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  racesRaceGuidPost(params: RacesRaceGuidPost$Params, context?: HttpContext): Observable<Race> {
    const resp = this.racesRaceGuidPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Race>): Race => r.body)
    );
  }

  /** Path part for operation `deleteRace()` */
  static readonly DeleteRacePath = '/races/{raceGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRace()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRace$Response(params: DeleteRace$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteRace(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRace$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRace(params: DeleteRace$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteRace$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
